module.exports = __webpack_public_path__ + "img/3f_r_pizzala@2x.d5bd8aca.png";